var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',_vm._l((_vm.navLinks),function(link){return (_vm.isFetchComplete)?_c('NavLink',{key:link.id,attrs:{"id":link.id,"label":link.label || '',"route":link.route,"classes":link.classes,"type":_vm.navbarType}}):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }